import { useEffect, useState } from "react";
import { db } from "../FirebaseConfig";
import Product from "./Product";


const ProductFeed = () => {
    const [products, setProducts] = useState([]);
    
    useEffect(() => {
        db.collection('PRODUCTS').onSnapshot(snapshot => {
            setProducts(snapshot.docs.map(doc => ({
                id : doc.id,
                product : doc.data()
            })));
        })  
    }, []);
    
    return(
        <div className = 'productFeed'>
            <h4>Featured on the store</h4>
            <div className = 'productFeedProducts'>
                {
                    products.map(({id, product}) => (
                        <Product key = {id}
                             id = {id}
                             image = {product.product_image}
                             price = {product.product_price}
                             name = {product.product_name}
                        />
                    ))
                }
            </div>
        </div>
    );
}

export default ProductFeed;